// styles for Button Component
import { buttonStyles } from '../../../styles';

// Button Component
const Button = ({ title, direction, onClick, disabled }) => {
  return direction === 'left' ? (
    <button
      type="button"
      className={`btn ${!disabled ? `btn-primary` : ``}`}
      onClick={onClick}
      disabled={disabled}
    >
      <div style={buttonStyles}>&nbsp; {title} &nbsp;</div>
    </button>
  ) : direction === 'right' ? (
    <button
      type="button"
      className={`btn ${!disabled ? `btn-primary` : ``}`}
      onClick={onClick}
      disabled={disabled}
    >
      <div style={buttonStyles}>&nbsp; {title} &nbsp;</div>
    </button>
  ) : (
    <button
      type="button"
      className={`btn ${!disabled ? `btn-primary` : ``}`}
      onClick={onClick}
      disabled={disabled}
    >
      <div style={buttonStyles}>&nbsp; {title} &nbsp;</div>
    </button>
  );
};

export default Button;
